var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg19WebsiteDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    className: "fil-illu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fil-illu__lines",
    fill: "none",
    stroke: "#414956",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "12 55 1 55 1 1 63 1 63 55 52 55"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    x2: 63,
    y1: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 6,
    y1: 5,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 10,
    y1: 5,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 14,
    y1: 5,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 17,
    y1: 1,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 60,
    y1: 5,
    y2: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 51 5 51 5 13 59 13 59 51 52 51"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 20,
    y1: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 24,
    y1: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 18,
    y1: 25,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    x2: 32,
    y1: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    x2: 44,
    y1: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 26,
    y1: 25,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 16,
    y1: 29,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    x2: 30,
    y1: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.15,37.09l-5.471.151,1.836-5.161A17.982,17.982,0,0,0,40.427,29.1l-4.349,3.346L34.532,27.2a16.214,16.214,0,0,0-5.065,0l-1.546,5.246L23.572,29.1a17.982,17.982,0,0,0-4.088,2.981l1.836,5.161-5.47-.152a17.887,17.887,0,0,0-1.565,4.816L18.8,45l-4.516,3.094a17.887,17.887,0,0,0,1.565,4.816l5.471-.151L19.484,57.92a17.948,17.948,0,0,0,4.088,2.98l4.349-3.346L29.467,62.8a16.18,16.18,0,0,0,5.066,0l1.546-5.246L40.428,60.9a18.008,18.008,0,0,0,4.088-2.98L42.68,52.76l5.471.151A17.852,17.852,0,0,0,49.716,48.1L45.2,45l4.516-3.094A17.853,17.853,0,0,0,48.15,37.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 45,
    r: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg19WebsiteDevelopment);
export default __webpack_public_path__ + "static/media/19_website_development.e8b5f6104dae49272dd703037a62a88c.svg";
export { ForwardRef as ReactComponent };